<iu-multi-level-autocomplete-ui
  [groups]="suggestions | async"
  (selectionChanged)="onSelectionChanged($event)"
  [placeholder]="'tagsEditor.addTag' | translate"
  #autocomplete />
